import { defineComponent, reactive, ref, watch } from 'vue';
import { gsap } from 'gsap';
import NavSubItem from '@/components/navigation/NavSubItem.vue';
export default defineComponent({
    name: 'NavMainItem',
    components: {
        NavSubItem,
    },
    props: {
        navItem: {
            type: Object,
            required: true,
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const subMenuContainer = ref();
        const state = reactive({
            show: false,
        });
        watch(() => state.show, (show) => {
            if (props.navItem.code == 'report') {
                if (show) {
                    gsap.to([subMenuContainer.value], {
                        paddingLeft: '430px',
                        duration: 0.3,
                    });
                    return;
                }
                gsap.to([subMenuContainer.value], {
                    paddingLeft: '380px',
                    duration: 0.3,
                });
            }
            else if (props.navItem.code === 'home-appliance') {
                if (show) {
                    gsap.to([subMenuContainer.value], {
                        paddingLeft: '550px',
                        duration: 0.3,
                    });
                    return;
                }
                gsap.to([subMenuContainer.value], {
                    paddingLeft: '500px',
                    duration: 0.3,
                });
            }
        });
        const onClick = (e) => {
            emit('click', e, props.navItem.path);
        };
        const onSubClick = (e, path) => {
            emit('click', e, path);
        };
        return {
            state,
            subMenuContainer,
            onClick,
            onSubClick,
        };
    },
});
